import React from 'react';
import { Box, IconButton, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { styles, ModalProps, stylesModal } from './types';
import style from './style.module.css';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export default function ModalMoreInfoLinked({ open, handleClose }) {
  const ART_43 = `
    Artículo 43.- Presunción de Acceso.- Salvo prueba en contrario, para efectos de la presente ley, se presume que poseen información privilegiada:

    a) Los directores y gerentes del emisor y de los inversionistas institucionales, así como los miembros del Comité de Inversiones de estos últimos, en su caso;

    b) Los directores y gerentes de las sociedades vinculadas al emisor y a los inversionistas institucionales;

    c) Los accionistas que individualmente o conjuntamente con sus cónyuges y parientes hasta el primer grado de consanguinidad, posean el diez por ciento (10%) o más del capital del emisor o de los inversionistas institucionales; y,

    d) El cónyuge y los parientes hasta el primer grado de consanguinidad de las personas mencionadas en los incisos precedentes.

    (Texto según el artículo 41 del Decreto Legislativo N° 861).
    `;

  const ART_44 = `
    Artículo 44.- Otras presunciones.- Además, salvo prueba en contrario, para efectos de la presente ley, se presume que tienen información privilegiada, en la medida que hubieran tenido la posibilidad de acceder al hecho objeto de la información, las siguientes personas:

    (Texto según el primer párrafo artículo 42 del Decreto Legislativo N° 861, modificado según el artículo 1 del Decreto Legislativo N° 1061).

    a) Los socios, administradores, y personal encargado de la auditoria de las sociedades auditoras contratadas por el emisor;

    (Texto según el inciso a) del artículo 42 del Decreto Legislativo N° 861, modificado según el artículo 1 del Decreto Legislativo N° 1061).

    b) Los accionistas, socios, directores, administradores y miembros del: i) Comité de clasificación de las clasificadoras, ii) Comisión clasificadora de inversiones a que se refiere el Decreto Ley Nº 25897, iii) Empresas proveedoras de precios de que trata el Título XIV de la presente ley, iv) Entidades a que se refiere el artículo 74 de la ley, v) Las valorizadoras para los fines de las ofertas públicas de adquisición y vi) Las mencionadas en la Ley Nº 28739;

    (Texto según el inciso b) del artículo 42 del Decreto Legislativo N° 861, modificado según el artículo 1 del Decreto Legislativo N° 1061).

    c) Los administradores, asesores, operadores y demás representantes de los agentes de intermediación;

    d) Los miembros del consejo directivo, gerentes y demás funcionarios de las bolsas y entidades responsables de la conducción de mecanismos centralizados;

    e) Los directores, funcionarios de las instituciones encargadas del control o supervisión de emisores de valores de oferta pública o inversionistas institucionales, incluyendo la SMV, y la Superintendencia;

    (Texto según el inciso e) del artículo 42 del Decreto Legislativo N° 861, modificado según el artículo 1 del Decreto Legislativo N° 1061).

    f) Los directores, gerentes y demás funcionarios de las instituciones de compensación y liquidación de valores;

    g) Los dependientes que trabajen bajo la dirección o supervisión directa de los directores, gerentes, administradores o liquidadores del emisor e inversionistas institucionales;

    h) Las personas que presten servicios de asesoría temporal o permanente al emisor vinculadas a la toma de decisiones de gestión;

    i) Los funcionarios de las instituciones financieras que estén a cargo de los créditos a favor del emisor;

    j) Los funcionarios del emisor y de los inversionistas institucionales, así como de sus sociedades vinculadas; y,

    k) Los parientes de las personas señaladas en los incisos a), b) y c) del artículo anterior y de las mencionadas en los incisos precedentes.
    `;

  const WideTooltip = withStyles(() => ({
    tooltip: {
      maxWidth: 800,
      fontSize: '0.55rem',
      lineHeight: 1,
      padding: '12px 16px',
      whiteSpace: 'pre-line',
      textAlign: 'justify',
    },
  }))(Tooltip);

  return (
    <Modal
      style={stylesModal}
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box style={styles}>
        <div className={style.header}>
          <h1 className={style.title}>Relación con la SAFI</h1>
          <IconButton
            onClick={handleClose}
            style={{ position: 'absolute', top: 10, right: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className={style.content}>
          <p>
            Vinculación con Core Capital SAFI o empresas de su Grupo Económico
          </p>
          <p>
            <strong>Persona Sujeta</strong>
          </p>
          <p>
            <strong>Eres una Persona Sujeta si:</strong>
          </p>
          <ul>
            <li>
              {' '}
              Ocupas <strong>cargos clave</strong> en{' '}
              <strong>Core Capital SAFI, Edifica o Produktiva</strong>, tales
              como accionista, director, gerente, miembro de los comités o si
              eres una persona encargada de ejecutar las decisiones de inversión
              de alguno de los fondos administrado por Core Capital SAFI.
              Asimismo, si en el desempeño de tus funciones puedes tomar
              conocimiento de alguna información privilegiada o confidencial, de
              acuerdo con los artículos
              <WideTooltip
                title={<span style={{ whiteSpace: 'pre-line' }}>{ART_43}</span>}
                arrow
                placement="top"
              >
                <span style={{ cursor: 'pointer', color: '#1976d2' }}>
                  {' '}
                  43*{' '}
                </span>
              </WideTooltip>
              y
              <WideTooltip
                title={<span style={{ whiteSpace: 'pre-line' }}>{ART_44}</span>}
                arrow
                placement="top"
              >
                <span style={{ cursor: 'pointer', color: '#1976d2' }}>
                  {' '}
                  44*{' '}
                </span>
              </WideTooltip>
              del TUO de la Ley del Mercado de Valores.
            </li>
            <li>
              {' '}
              O si tienes <strong>familiares</strong> que ocupen alguno de estos{' '}
              <strong>cargos claves</strong>.{' '}
            </li>
          </ul>
          <p>
            <strong>Se consideran familiares:</strong>
          </p>
          <ul>
            <li>
              {' '}
              <strong>Hasta el segundo grado de consanguinidad:</strong>{' '}
              abuelos, padres, hermanos, hijos y nietos.
            </li>
            <li>
              {' '}
              <strong>Hasta el primer grado de afinidad:</strong> cónyuge o
              conviviente, suegros, yernos y nueras.
            </li>
          </ul>
        </div>
      </Box>
    </Modal>
  );
}
